export interface IApiError {
  httpStatusCode: number;
  message: string;
  data?: Record<string, string>;
  url?: string;
  code?: string;
  availableFrom?: number;
  availableTo?: number;
}

export class ApiError extends Error {
  readonly httpStatusCode: number;
  readonly data?: Record<string, string>;
  readonly url?: string;
  /** Structured analytics error code from the `{error:{code,...}}` envelope (ADR-003 §8). */
  readonly code?: string;
  /** UTC epoch seconds; present on coverage/product-window errors. */
  readonly availableFrom?: number;
  /** UTC epoch seconds; present on coverage errors. */
  readonly availableTo?: number;

  constructor(error: IApiError) {
    super(error.message);
    this.name = 'ApiError';
    this.httpStatusCode = error.httpStatusCode;
    this.data = error.data;
    this.url = error.url;
    this.code = error.code;
    this.availableFrom = error.availableFrom;
    this.availableTo = error.availableTo;
  }

  get isConflict(): boolean {
    return this.httpStatusCode === 409;
  }

  get isAuthError(): boolean {
    return this.httpStatusCode === 401 || this.httpStatusCode === 403;
  }
}
